import './App.css';
import { useEffect, useRef } from 'react';
import blackChair from './Images/black_chair.avif';
import jellyFish from './Images/jelly_fish.avif';
import wtfAlien from './Images/wtf_alien.avif';
import space from './Images/space.avif';
import science from './Images/science.avif';
import blueBook from './Images/blue_book.avif';
import classroomImage from './Images/classroom.avif';
import collaborationImage from './Images/collaboration.avif';
import presentationImage from './Images/presentation.avif';
document.body.style.background = '#000';
document.body.style.color = '#fff';

function App() {
  const imageRefs = useRef([]);
  const homeRef = useRef(null);
  const aboutRef = useRef(null);
  const articlesRef = useRef(null);

  // Smooth scroll function
  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      const header = document.querySelector('.top-header');
      const headerHeight = header ? header.offsetHeight + 20 : 100;
      
      const element = ref.current;
      const elementTop = element.offsetTop;
      const offsetPosition = elementTop - headerHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    const getObserverOptions = () => {
      const isMobile = window.innerWidth <= 768;
      return {
        threshold: isMobile ? 0.1 : 0.2,
        rootMargin: isMobile ? '0px 0px -30px 0px' : '0px 0px -50px 0px'
      };
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-visible');
        }
      });
    }, getObserverOptions());

    imageRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      imageRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <div className="App">
      {/* HEADER/NAVBAR */}
      <header className="top-header">
        <div className="header-left">
          <img src={blueBook} alt="UTD Science Communications Club Logo" className="header-logo" />
          <span className="header-club-name">UTD Science Communications Club</span>
        </div>
        <nav className="header-nav">
          <a 
            href="#home" 
            className="nav-link active"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(homeRef);
            }}
          >
            Home
          </a>
          <a 
            href="#about" 
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(aboutRef);
            }}
          >
            About Us
          </a>
          <a 
            href="#articles" 
            className="nav-link"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection(articlesRef);
            }}
          >
            Articles
          </a>
        </nav>
      </header>

      {/* HERO SECTION */}
      <section id="home" ref={homeRef} className="hero-section">
        <h1 className="hero-title">The Science Hub</h1>
        <p className="hero-description">
          Welcome to our platform dedicated to scientific storytelling. Join us in exploring the wonders of science and innovation.
        </p>
        <button 
          className="join-btn"
          onClick={() => scrollToSection(articlesRef)}
        >
          Join the Club
        </button>
        <div className="hero-collage">
          <img
            ref={(el) => (imageRefs.current[0] = el)}
            src={jellyFish}
            className="collage-image collage-image-1"
            alt="Jellyfish"
          />
          <img
            ref={(el) => (imageRefs.current[1] = el)}
            src={science}
            className="collage-image collage-image-2"
            alt="Science"
          />
          <img
            ref={(el) => (imageRefs.current[2] = el)}
            src={space}
            className="collage-image collage-image-3"
            alt="Outer space science"
          />
          <img
            ref={(el) => (imageRefs.current[3] = el)}
            src={wtfAlien}
            className="collage-image collage-image-4"
            alt="Painting of an alien"
          />
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section id="about" ref={aboutRef} className="about-section">
        <div className="about-content">
          <div className="about-image-group">
            <img
              src={blackChair}
              className="about-chair-image"
              alt="Black chair"
            />
          </div>
          <div className="about-text-group">
            <h3 className="about-story-title">Our Story</h3>
            <p className="about-story">
              The UTD Science Communications Club is a vibrant community passionate about sharing the marvels of science through compelling narratives. We aim to inspire curiosity and foster a deeper understanding of scientific concepts through engaging content and activities. Join us on this enlightening journey!
            </p>
            <button 
              className="learn-more-btn"
              onClick={() => scrollToSection(articlesRef)}
            >
              Learn More
            </button>
          </div>
        </div>
      </section>

      {/* ARTICLES SECTION */}
      <section id="articles" ref={articlesRef} className="articles-section">
        <div className="articles-content">
          <h2 className="articles-title">Featured Articles</h2>
          <p className="articles-description">
            Explore our collection of science articles, research insights, and thought-provoking content.
          </p>
          <div className="articles-grid">
            <div className="article-card">
              <img src={classroomImage} alt="Classroom learning environment" className="article-image" />
              <h3 className="article-card-title">Innovative Learning Spaces</h3>
              <p className="article-card-description">
                Discover how modern classroom environments enhance scientific education and foster collaborative learning experiences.
              </p>
            </div>
            <div className="article-card">
              <img src={collaborationImage} alt="Students collaborating" className="article-image" />
              <h3 className="article-card-title">Collaborative Science</h3>
              <p className="article-card-description">
                Explore how teamwork and collaboration drive scientific breakthroughs and innovation in research.
              </p>
            </div>
            <div className="article-card">
              <img src={presentationImage} alt="UTD Science Communications presentation" className="article-image" />
              <h3 className="article-card-title">Science Communication</h3>
              <p className="article-card-description">
                Learn about effective ways to communicate complex scientific concepts and share knowledge with diverse audiences.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
